/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mPopSpinsPriceList.vue?vue&type=template&id=3d82c46a"
import script from "./mPopSpinsPriceList.vue?vue&type=script&lang=js"
export * from "./mPopSpinsPriceList.vue?vue&type=script&lang=js"
import style0 from "./mPopSpinsPriceList.vue?vue&type=style&index=0&id=3d82c46a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports